<div class="container about-us">
  <div class="about-us__hero">
    <img
      src="assets/images/about-us/japan-earthquake-2011.jpg"
      [alt]="'ABOUT-US_HERO-ALT' | translate"
    />
  </div>

  <nav class="about-us__tabs" [attr.aria-label]="'ABOUT-US_TABS-LABEL' | translate">
    <a
      class="about-us__tab"
      *ngFor="let tab of tabs; trackBy: trackByRoute"
      [routerLink]="['/about-us', tab.route]"
      routerLinkActive="about-us__tab--active"
    >
      {{ tab.labelKey | translate }}
    </a>
  </nav>

  <div class="about-us__panel">
    <router-outlet></router-outlet>
  </div>
</div>
